import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';

import 'leaflet/dist/leaflet.css';
import './index.scss';

const Leaflet = typeof window !== `undefined` ? require('leaflet') : null;

const LeafletMap = ({ position, zoom, markerText }) => {
  useEffect(() => {
    delete Leaflet.Icon.Default.prototype._getIconUrl;

    Leaflet.Icon.Default.mergeOptions({
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
    });
  }, []);

  return (
    <MapContainer center={position} zoom={zoom}>
      <TileLayer
        attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}{r}.png"
      />
      {markerText !== '' && (
        <Marker position={position}>
          <Popup>{markerText}</Popup>
        </Marker>
      )}
    </MapContainer>
  );
};

LeafletMap.propTypes = {
  /** Latitude and Longitude of the map centre in an array, eg [51, -1] **/
  position: PropTypes.array,

  /** Initial zoom level for the map (default 13) **/
  zoom: PropTypes.number,

  /** If set, will display a marker, which when clicked will display this text **/
  markerText: PropTypes.string,
};

LeafletMap.defaultProps = {
  position: [51, -1],
  zoom: 13,
  markerText: '',
};

export default LeafletMap;
